var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.99525 14.5787L8.25 17.1875L7.50475 14.5787C7.31213 13.9048 6.95099 13.2911 6.4554 12.7955C5.95982 12.2999 5.34613 11.9388 4.67225 11.7462L2.0625 11L4.67133 10.2548C5.34521 10.0621 5.9589 9.70099 6.45449 9.2054C6.95007 8.70982 7.31122 8.09613 7.50383 7.42225L8.25 4.8125L8.99525 7.42133C9.18787 8.09521 9.54901 8.7089 10.0446 9.20449C10.5402 9.70007 11.1539 10.0612 11.8278 10.2538L14.4375 11L11.8287 11.7452C11.1548 11.9379 10.5411 12.299 10.0455 12.7946C9.54993 13.2902 9.18878 13.9039 8.99617 14.5778L8.99525 14.5787ZM16.7374 7.98875L16.5 8.9375L16.2626 7.98875C16.1267 7.44479 15.8455 6.94799 15.4491 6.55144C15.0528 6.1549 14.5561 5.87353 14.0122 5.73742L13.0625 5.5L14.0122 5.26258C14.5561 5.12647 15.0528 4.8451 15.4491 4.44856C15.8455 4.05201 16.1267 3.55521 16.2626 3.01125L16.5 2.0625L16.7374 3.01125C16.8734 3.55532 17.1547 4.05221 17.5512 4.44876C17.9478 4.84531 18.4447 5.12661 18.9888 5.26258L19.9375 5.5L18.9888 5.73742C18.4447 5.87339 17.9478 6.15469 17.5512 6.55124C17.1547 6.94779 16.8734 7.44468 16.7374 7.98875ZM15.4862 18.8531L15.125 19.9375L14.7638 18.8531C14.6626 18.5493 14.492 18.2733 14.2656 18.0469C14.0392 17.8205 13.7632 17.6499 13.4594 17.5487L12.375 17.1875L13.4594 16.8263C13.7632 16.7251 14.0392 16.5545 14.2656 16.3281C14.492 16.1017 14.6626 15.8257 14.7638 15.5219L15.125 14.4375L15.4862 15.5219C15.5874 15.8257 15.758 16.1017 15.9844 16.3281C16.2108 16.5545 16.4868 16.7251 16.7906 16.8263L17.875 17.1875L16.7906 17.5487C16.4868 17.6499 16.2108 17.8205 15.9844 18.0469C15.758 18.2733 15.5874 18.5493 15.4862 18.8531Z",
    stroke: "url(#paint0_linear_133_28594)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_133_28594",
    x1: 2,
    y1: 2,
    x2: 20,
    y2: 20,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#24F0BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4068EB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAi);
export default __webpack_public_path__ + "static/media/ai.1aad0b33c605901b24f0c5782924f72e.svg";
export { ForwardRef as ReactComponent };